import {
  GET_DATA,
  GET_DATA_SUCCESS,
  GET_DATA_FAIL,
  SET_PAGE,
  CLEAR_DATA,
  CLEAR_DATA_SUCCESS
} from "./actionTypes";

const INIT_STATE = {
  selectedCompany: null,
  data: [],
  page: 1,
  length: 10,
  totalPage: 1,
  totalData: 0,
  error: '',
  loading: false,
  filter: {}
};

const DataTable = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_DATA:
      return {
        ...state,
        loading: true,
        filter: action.payload.filter
      };
    case GET_DATA_SUCCESS:
      return {
        ...state,
        data: action.payload.list,
        page: action.payload.page,
        length: action.payload.length,
        totalPage: action.payload.totalPage,
        totalData: action.payload.totalData,
        loading: false,
      };
    case GET_DATA_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case SET_PAGE:
      return {
        ...state,
        page: action.payload.page,
        length: action.payload.length,
      };

    case CLEAR_DATA:
      return {
        ...state,
        loading: true,
      };

    case CLEAR_DATA_SUCCESS:
      return {
        ...state,
        data: [],
        page: 1,
        length: 10,
        totalPage: 1,
        totalData: 0,
        error: '',
        loading: false,
        filter: {}
      };

    default:
      return state;
  }
};

export default DataTable;
